module.exports = __webpack_public_path__ + "static/tangled-in-a-circle_ceramic-installation-fa93431eba64726393b00e027b331cb4.jpg";